// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"031f5234","136":"2cd8aa71","174":"5843ff4a","214":"3f953543","255":"7b86f385","354":"594b07e1","524":"1235c3a8","580":"5030455e","605":"b3d8453b"}[chunkId] + ".chunk.js";
};